:host {
  width: auto;
  height: 340px;
}

:host > div {
  position: relative;
  display: flex;
  width: auto;
  height: 340px;
  align-items: center;
  justify-content: center;
}
